module.exports = __webpack_public_path__ + "img/智慧园林综合管理平台V1.0.be5bd2c6.jpg";